var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { customFetch } from "@filadd/phi-plus-core";
import { useInfiniteQuery, } from "@tanstack/react-query";
import { NOTIFICATIONS_API_BASE_PATH, NOTIFICATIONS_KEY_PREFIX, PAGE_SIZE, } from "./constants";
const generateNotificationsInfiniteQueryKey = (options = {}) => [NOTIFICATIONS_KEY_PREFIX, "infinite-list", options];
const fetchNotifications = ({ queryKey: [, , { unread, format, sortDirection }], pageParam, meta: { baseURL, authToken, locale } = {}, }) => {
    if (baseURL == null) {
        throw new Error("baseURL in meta required");
    }
    const params = {
        page: pageParam.toString(),
    };
    if (unread != null) {
        params.seen = "false";
    }
    if (format != null) {
        params.format = format;
    }
    if (sortDirection != null) {
        params.sort_direction = sortDirection;
    }
    return customFetch(`${NOTIFICATIONS_API_BASE_PATH}/inapp/`, {
        baseURL,
        authToken,
        locale,
        params,
    });
};
export const useInfiniteNotifications = (_a) => {
    var { initialPageParam = 0, unread, format, sortDirection } = _a, options = __rest(_a, ["initialPageParam", "unread", "format", "sortDirection"]);
    return useInfiniteQuery(Object.assign({ queryKey: generateNotificationsInfiniteQueryKey({
            unread,
            format,
            sortDirection,
        }), queryFn: fetchNotifications, initialPageParam, getNextPageParam: (lastPage, pages) => lastPage.length === PAGE_SIZE ? pages.length : null }, options));
};
useInfiniteNotifications.keyWithoutOptions =
    generateNotificationsInfiniteQueryKey().slice(0, -1); // exclude options to match all queries
useInfiniteNotifications.generateKey = generateNotificationsInfiniteQueryKey;
useInfiniteNotifications.prefetchQuery = (queryClient, _a) => {
    var { unread, format, sortDirection, initialPageParam = 0 } = _a, options = __rest(_a, ["unread", "format", "sortDirection", "initialPageParam"]);
    return queryClient.prefetchInfiniteQuery(Object.assign({ queryKey: generateNotificationsInfiniteQueryKey({
            unread,
            format,
            sortDirection,
        }), queryFn: fetchNotifications, initialPageParam: initialPageParam !== null && initialPageParam !== void 0 ? initialPageParam : 0 }, options));
};
//# sourceMappingURL=useInfiniteNotifications.js.map